/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.programs.detail.prerequisites.controllers', [
  'acme.common.service.api',
  'acme.common.service.helpers'
])

.controller('ProgramsDetailPrerequisitesController', ['$scope', 'ResolveViewData', 'ResolveTemplatesData', 'ApiService', 'HelpersService', function($scope, ResolveViewData, ResolveTemplatesData, ApiService, HelpersService) {

    $scope.programsDetailPrerequisites = {

      isAdding: false,
      emptyImage: '/assets/img/global/empty-event-image.jpg',
      previewImage: '',

      model: {},
      program: {},

      // Whether the dependencies are AND/OR
      selectedOperation: "allOf",

      search: {},
      savedSummaries: [],
      summaries: [],
      templates: [],

      currentPrerequisite: {},

      strip: HelpersService.strip,

      init: function() {
        if (ResolveViewData.data && ResolveViewData.data.success) {
          this.success.init(ResolveViewData);
        }else{
          this.error.init(ResolveViewData);
        }

        if (ResolveTemplatesData.data && ResolveTemplatesData.data.success) {
          this.success.initSummaries(ResolveTemplatesData);
        }else{
          this.error.initSummaries(ResolveTemplatesData);
        }

      },

      showTemplates: function() {
        this.isAdding = true;
      },

      hideTemplates: function() {
        this.isAdding = false;
      },

      toggleTemplates: function() {
        this.isAdding = !this.isAdding;
      },

      preview: function(template) {
        this.previewImage = (template && template.primaryImage && template.primaryImage.preview) ? template.primaryImage.preview : false;
      },

      getPrereqStub: function() {
        return {
          eventTemplateId: '',
          min: {
            days: 0,
            hours: 0,
            minutes: 1,
            endOfDay: false
          },
          max: {
            days: 365,
            hours: 0,
            minutes: 0,
            endOfDay: false
          }
        };
      },

      findSummary: function(id) {
        var i, ii,
            r = false;

        for (i=0,ii=this.savedSummaries.length;i<ii;i++) {
          if (this.savedSummaries[i].id === id) {
            r = this.savedSummaries[i];
            break;
          }
        }

        return r;
      },

      addTemplate: function(id) {
        var i, ii,
            j, jj,
            merged = {};

        for(i=this.summaries.length-1,ii=0;i>=ii;i--) {
          if (this.summaries[i].id === id) {
            merged = this.summaries.splice(i, 1)[0];
            for(j=0,jj=this.model.prerequisites.length;j<jj;j++) {
              if (this.model.prerequisites[j].eventTemplateId === id) {
                HelpersService.decorate(merged, this.model.prerequisites[j]);
                break;
              }
            }
            this.templates.push(merged);
          }
        }
      },

      stripExisting: function(templates) {
        var i, ii,
            j, jj,
            merged = {};

        for (i=templates.length-1,ii=0;i>=ii;i--) {
          if (templates[i].id === this.program.id) {
            templates.splice(i, 1);
            continue;
          }
          if (this.hasPrerequisites()) {
            for (j = 0, jj = this.model.prerequisites.length; j < jj; j++) {
              if (templates[i].id === this.model.prerequisites[j].eventTemplateId) {
                // Load templates which already exist
                console.log('ProgramsDetailPrerequisitesController::stripExisting', templates[i].id);
                merged = templates.splice(i, 1)[0];
                HelpersService.decorate(merged, this.model.prerequisites[j]);
                this.templates.push(merged);
                break;
              }
            }
          }
        }
        console.log('ProgramsDetailPrerequisitesController::stripExisting', this.templates);

        return templates;

      },

      pruneTemplates: function() {
        var i, ii,
            j, jj,
            tmp = [];

        for (j=0,jj=this.model.prerequisites.length;j<jj;j++) {
          for (i=0,ii=this.templates.length;i<ii;i++) {
            if (this.templates[i].id === this.model.prerequisites[j].eventTemplateId) {
              tmp.push(this.templates[i]);
              break;
            }
          }
        }
        console.log('ProgramsDetailPrerequisitesController::pruneTemplates', tmp);

        this.templates = tmp.slice(0);
      },

      hasPrerequisites: function() {
        return (this.model && this.model.prerequisites instanceof Array && this.model.prerequisites.length > 0);
      },

      add: function(id) {

        this.currentPrerequisite = this.getPrereqStub();

        this.currentPrerequisite.eventTemplateId = id;

        this.previewImage = false;

        if (!this.model) {
          this.model = {
            operation: this.selectedOperation,
            prerequisites: [this.currentPrerequisite]
          };
          $scope.programsDetailPrerequisites.create();
        }else{
          this.model.prerequisites.push(this.currentPrerequisite);
          $scope.programsDetailPrerequisites.update();
        }
        this.addTemplate(id);

      },

      create: function() {
        ApiService.program.prerequisites.create(this.program.id, this.model).then(this.success.create, this.error.create);
      },

      remove: function(id) {
        var i, ii,
            removed = {};

        if (this.hasPrerequisites()) {

          for (i=0,ii=this.model.prerequisites.length;i<ii;i++) {
            console.log('ProgramsDetailPrerequisitesController::remove', (id === this.model.prerequisites[i].eventTemplateId));
            if (this.model.prerequisites[i].eventTemplateId === id) {
              console.log('ProgramsDetailPrerequisitesController::remove', this.model.prerequisites[i].eventTemplateId);
              removed = this.model.prerequisites.splice(i, 1);
              this.summaries.push(this.findSummary(removed[0].eventTemplateId));
              break;
            }
          }
          console.log('ProgramsDetailPrerequisitesController::remove', this.model.prerequisites);

          // If we've removed the last prerequisite we must clear the entire object
          // Otherwise we can simply update
          if (this.hasPrerequisites()) {
            ApiService.program.prerequisites.update(this.program.id, this.model).then(this.success.remove, this.error.remove);
          }else {
            ApiService.program.prerequisites.remove(this.program.id).then(this.success.remove, this.error.remove);
          }
        }
      },

      update: function() {
        console.log('ProgramsDetailPrerequisitesController::update', this.model);
        ApiService.program.prerequisites.update(this.program.id, this.model).then(this.success.update, this.error.update);
      },

      success: {
        init: function(response) {
          console.log('ProgramsDetailPrerequisitesController::success::init', response);
          if (!response.data.payload) { return; }
          $scope.programsDetailPrerequisites.program = response.data.payload;
          $scope.programsDetailPrerequisites.model = $scope.programsDetailPrerequisites.program.prerequisites;
        },

        initSummaries: function(response) {
          console.log('ProgramsDetailPrerequisitesController::success::initTemplates', response);
          if (!response.data.summaries) { return; }
          $scope.programsDetailPrerequisites.savedSummaries = response.data.summaries.slice(0);
          $scope.programsDetailPrerequisites.summaries = $scope.programsDetailPrerequisites.stripExisting(response.data.summaries);
        },

        create: function(response) {
          $scope.programsDetailPrerequisites.hideTemplates();
          $scope.programsDetailPrerequisites.addTemplate($scope.programsDetailPrerequisites.currentPrerequisite.eventTemplateId);
          $scope.programsDetailPrerequisites.currentPrerequisite = {};
        },
        remove: function(response) {
          $scope.programsDetailPrerequisites.pruneTemplates();
        },
        update: function(response) {
          $scope.programsDetailPrerequisites.success.create(response);
        }

      },

      error: {
        init: function(response) {},
        initSummaries: function(response) {},
        getTemplate: function(response) {},

        create: function(response) {},
        remove: function(response) {},
        update: function(response) {}
      }

    };

    $scope.programsDetailPrerequisites.init();
    
}]);